module.exports = __webpack_public_path__ + "static/media/MRH-main-icon.ca78ed6b.svg";